<template>
  <div :class="{_open: isOpen}" class="ui-accordion-item">
    <div v-if="badges.length" class="ui-accordion-item__badges">
      <Badge
          v-for="(badge, idx) in badges" :key="`${refName}-badge-${idx}`"
          :title="badge.title"
          :link="badge.link"
          :type="badge.type"
          :iconSrc="badge.iconSrc"
          :isLinkBlank="badge.isLinkBlank"
          :isSmall="badge.isSmall"
      />
    </div>
    <div class="ui-accordion-item__header" @click="toggleBody">
      <p class="ui-accordion-item__title h4-semibold">{{ title }}</p>
      <div class="ui-accordion-item__icon"></div>
    </div>
    <div class="ui-accordion-item__body">
      <div class="ui-accordion-item__wrapper">
        <div :class="{'_full': isFull}" class="ui-accordion-item__content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Badge from './Badge.vue';

export default {
  name: "AccordionElement",
  components: { Badge },
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    title: {
      type: String,
      default: "Заголовок",
    },
    refName: {
      type: String,
      required: true
    },
    badges: {
      type: Array,
      default () {
        return [];
      }
    },
    isLinkBlank: {
      type: Boolean,
      default: false
    },
    isFull: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleBody() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.$emit('open', this.refName);
      } else {
        this.$emit('close', this.refName);
      }
    }
  }
};
</script>